<template>
  <div class="text-carousel">
    <transition-group name="slide" tag="div" class="text-carousel__container">
      <div
        v-for="(text, index) in texts"
        :key="text"
        v-show="currentIndex === index"
        class="text-carousel__item"
      >
        {{ text }}
      </div>
    </transition-group>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue';

const props = defineProps({
  texts: {
    type: Array as () => string[],
    required: true
  },
  interval: {
    type: Number,
    default: 3000
  }
});

const currentIndex = ref(0);
let timer: number | null = null;

const next = () => {
  currentIndex.value = (currentIndex.value + 1) % props.texts.length;
};

const startTimer = () => {
  timer = window.setInterval(next, props.interval);
};

const stopTimer = () => {
  if (timer) {
    clearInterval(timer);
    timer = null;
  }
};

onMounted(() => {
  startTimer();
});

onUnmounted(() => {
  stopTimer();
});
</script>

<style scoped lang="scss">
.text-carousel {
  position: relative;
  overflow: hidden;
  height: 24px;

  &__container {
    position: relative;
    height: 100%;
  }

  &__item {
    position: absolute;
    height: 100%;
    display: flex;
    align-items: center;
  }
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s ease;
}

.slide-enter-from {
  transform: translateY(100%);
  opacity: 0;
}

.slide-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}

.app-promotion__topSubtitle{
  .text-carousel__item {
    background: var(--on-container-label-blue);
    color: var(--on-container-text-blue);
    padding: var(--padding-2) var(--padding-4);
    border-radius: var(--corner-3);
  }
}
</style> 